import { CdsAutocomplete } from '@chicksgroup/web-components';
import { bindable, capture, EventAggregator, ICustomElementViewModel, inject } from 'aurelia';
import { Helper } from '../../extensions';

@inject(Element, EventAggregator, Helper)
@capture()
export class DbAutocompleteFilter implements ICustomElementViewModel {
    dbAutocompleteFilter: CdsAutocomplete;
    selectedItems = [];
    @bindable label: string;
    @bindable items: any[];

    constructor(private element: Element, private eventAggregator: EventAggregator, private helper: Helper) {
        this.element = element;
        this.eventAggregator = eventAggregator;
        this.helper = helper;
    }

    binding() {
        this.buildOptions();
    }

    attached() {
        this.handleEventAggregator();
    }

    buildOptions() {
        setTimeout(() => {
            this.dbAutocompleteFilter.items = this.items;
        });
    }

    handleItemSelected(event: CustomEvent): void {
        event.stopPropagation();
        this.selectedItems = [];
        const selectedDetail = event.detail;
        const selectedLabel = selectedDetail?.label || selectedDetail?.value;
        this.selectedItems = this.selectedItems.concat(selectedLabel);
        this.dbAutocompleteFilter.setValue(selectedLabel);
        this.dispatchEvent(event.detail);
    }

    dispatchEvent(detail) {
        const dispatchEvent = new CustomEvent('itemselected', {
            detail,
            bubbles: true,
            composed: true
        });

        this.element.dispatchEvent(dispatchEvent);
    }

    handleEventAggregator() {
        this.helper.debounce(this, 'eventHandler', 'eventHandlerTimeout', 600, () => {
            this.eventAggregator.subscribe('clear-all-filters', () => {
                this.dbAutocompleteFilter?.setValue(this.items?.at(0)?.label);
                this.dbAutocompleteFilter?.selectItem(0);
            });
        });
    }
}
